import { TruthyConfigValue, AppSettings } from "../types";

/**
 * Checks if the given value is meant to be truthy (e.g. strings '1' or 'true' indicate boolean true).
 *
 * @param value - The value to check.
 * @returns `true` if the value indicates true, `false` otherwise.
 */
const isTrueValue = (value: TruthyConfigValue) => ["1", "true", 1, true].includes(value);

const appSettings: AppSettings = {
  ...(window?.wvusFlexCheckoutSettings || {}),
  eventData: window?.wvusChosenEventData?.[0] || {},
  tourData: window?.wvusTourData || {},
  ...((window?.wvusCobrand && { cobrand: window?.wvusCobrand }) || {}),
  allowMultipleQuantity: isTrueValue(window?.wvusFlexCheckoutSettings?.allowMultipleQuantity),
  showPhotoConsentOption: isTrueValue(window?.wvusFlexCheckoutSettings?.showPhotoConsentOption),
  checkoutFlow: window?.wvusFlexCheckoutSettings?.checkoutFlow
    ? window?.wvusFlexCheckoutSettings.checkoutFlow
    : "PhotoFirst",
  chosenAuth: window?.wvusFlexCheckoutSettings?.chosenAuth
    ? window?.wvusFlexCheckoutSettings.chosenAuth
    : "",
  enableCCAuth: isTrueValue(window?.wvusFlexCheckoutSettings?.enableCCAuth),
  enablePayPal: isTrueValue(window?.wvusFlexCheckoutSettings?.enablePayPal),
  enableApplePay: isTrueValue(window?.wvusFlexCheckoutSettings?.enableApplePay),
  applePayMerchantId: window?.wvusFlexCheckoutSettings?.applePayMerchantId || "",
  showSmsPreference: isTrueValue(window?.wvusFlexCheckoutSettings?.showSmsPreference),
  smsOptinMessage: window?.wvusFlexCheckoutSettings?.smsOptinMessage,
  sakConfig: window?.wvusFlexCheckoutSettings?.sakConfig,
  sponsoredChildData: window?.wvusFlexCheckoutSettings?.sponsoredChildData || {},
  tokenExIframeStyles: [
    "font-family: Lato, Helvetica, Arial, sans-serif",
    "color: #7d7d7d",
    "font-size: 16px",
    "font-weight: 400",
    "padding: 0 12px", // 0 8px in mainline checkout
    "background: #FFF",
    "border: none",
    "margin: 0",
    "width: 100%",
    "line-height: 49px", // 30px in mainline checkout
    "height: 49px", // 37px in mainline checkout
    "box-sizing: border-box",
    "-moz-box-sizing: border-box",
    "-webkit-font-smoothing: antialiased" // not in mainline checkout
  ].join("; "),
  urls: (window?.WVUS_ENV_VARS && window.WVUS_ENV_VARS.urls) || {
    auth: "https://account.worldvision.org",
    cn: "https://cn.worldvision.org",
    core: "https://www.worldvision.org",
    core2: "https://mywv.worldvision.org",
    donate: "https://donate.worldvision.org",
    messages: "https://messages.worldvision.org",
    mywv: "https://my.worldvision.org",
    rmt: "https://serviceonemedia.wvi.org"
  },
  google_recaptcha_site_key: window?.wvusFlexCheckoutSettings?.google_recaptcha_site_key
};

export default appSettings;
